import { render, staticRenderFns } from "./ViberConfiguration.vue?vue&type=template&id=3bec2854"
import script from "./ViberConfiguration.vue?vue&type=script&lang=js"
export * from "./ViberConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports